/**
 * Statusul de plata al unei comenzi Shopify, cu „Retur" / „Nelivrată" cand a plecat si nu s-a
 * vandut. Folosit pe Comenzi si in detaliul de client, ca aceeasi comanda sa arate la fel peste tot.
 */

export const FINANCIAL_LABELS: Record<string, string> = {
  paid: 'Plătit',
  pending: 'În așteptare',
  authorized: 'Autorizat',
  partially_paid: 'Plătit parțial',
  refunded: 'Rambursat',
  partially_refunded: 'Rambursat parțial',
  voided: 'Anulat',
}

/*
  „Expediat", nu „Livrat" (Madalin, 12.10.2026). `fulfilled` in Shopify inseamna doar ca s-a creat
  expedierea — coletul a plecat. Pe ecran scria „Livrat" si langa comenzi plasate azi, si langa
  colete intarziate sau intoarse (#28695, #28693). Daca a ajuns la client stie curierul, nu
  statusul asta.
*/
export const FULFILLMENT_LABELS: Record<string, string> = {
  fulfilled: 'Expediat',
  partial: 'Expediat parțial',
  unfulfilled: 'Neexpediat',
  restocked: 'Returnat în stoc',
}

export const FINANCIAL_COLORS: Record<string, string> = {
  paid: 'bg-b4l-green-light text-b4l-green-dark',
  pending: 'bg-b4l-amber-light text-b4l-amber-dark',
  partially_paid: 'bg-b4l-amber-light text-b4l-amber-dark',
  refunded: 'bg-b4l-red-light text-b4l-red-dark',
  partially_refunded: 'bg-b4l-red-light text-b4l-red-dark',
  voided: 'bg-b4l-bg text-b4l-text-muted',
  authorized: 'bg-b4l-blue-light text-b4l-blue-dark',
}

/**
 * Comenzile expediate care nu s-au vandut: eticheta si motivul de la trecerea mouse-ului.
 *
 * „Retur" si „Nelivrata" stau separat (Madalin, 08.10.2026): un retur inseamna ca clientul a
 * primit marfa si a dat-o inapoi; o nelivrata n-a ajuns niciodata la el. O comanda anulata inainte
 * de expediere nu e niciuna — ramane „Anulat".
 */
const NEVANDUT: Record<string, { eticheta: string; motiv: string }> = {
  retur: {
    eticheta: 'Retur',
    motiv:
      'Retur — clientul a primit coletul și l-a trimis înapoi; banii au fost dați înapoi integral.',
  },
  livrare_esuata: {
    eticheta: 'Nelivrată',
    motiv: 'Livrare eșuată — coletul a fost refuzat sau neridicat și s-a întors prin curier.',
  },
  plata_anulata: {
    eticheta: 'Nelivrată',
    motiv:
      'Plata anulată după expediere — cel mai probabil colet refuzat; curierul n-a raportat starea.',
  },
}

/**
 * Statusul platii, sau „Retur" / „Nelivrata" cu rosu cand comanda a plecat si nu s-a vandut. Ia
 * locul statusului brut: „In asteptare" pe o comanda refuzata la livrare spunea ca banii mai vin.
 */
export function StatusPlata({
  financialStatus,
  motivNevandut,
}: {
  financialStatus: string | null
  motivNevandut: string | null
}) {
  const n = motivNevandut ? NEVANDUT[motivNevandut] : undefined
  if (n)
    return (
      <span
        className="inline-block cursor-help rounded bg-b4l-red-light px-1.5 py-0.5 text-[10px] font-semibold text-b4l-red-dark"
        title={n.motiv}
      >
        {n.eticheta}
      </span>
    )
  if (!financialStatus) return null
  return (
    <span
      className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-medium ${
        FINANCIAL_COLORS[financialStatus] ?? 'bg-b4l-bg'
      }`}
    >
      {FINANCIAL_LABELS[financialStatus] ?? financialStatus}
    </span>
  )
}
